import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {EiImportRecordStructureDto} from "../../../model/dto/entity/ei-import-record-structure.dto";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";


@Component({
    selector: 'ei-import-record-structure-object-component',
    templateUrl: 'ei-import-record-structure-object.component.html',
    standalone: false
})
export class EiImportRecordStructureObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    basicDataWidget: WidgetData;

    dto: EiImportRecordStructureDto

    /**
     * On Object Change.
     */
    onObjectChanged() {

        this.setPageTitle(this.dto.structureDtoName);
        this.refreshWidgets();
    }

    refreshWidgets() {

        this.basicDataWidget = WidgetFactory.createWidgetEntityData(
            "ei.import.record.structure.data.widget",
            "Ei Import Record Structure",
            "ei.EiImportRecordStructure",
            this.objectIdentifier.objectId);

    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
